import './GoPaperlessView.scss';

import React, { Fragment } from 'react';
import { ReactComponent as WarningImage } from 'assets/icons/yellow-waring-circle.svg';
import { ReactComponent as CheckImage } from 'assets/icons/check.svg';
import { AAMBeaconButton } from 'components/shared/Beacon';
import { connect } from 'react-redux';
import {
  getEligibleServiceTypeIds,
  isFullyPaperlessPreferences,
  isMFAccountServiceFeeWaived
} from 'state/preferences/PaperlessPreferencesSelectors';
import { hasOwnedMutualFunds } from 'state/account/AccountSelectors';
import { getPrimaryEmailAddress } from 'state/customer/CustomerSelectors';
import { Link } from 'react-router-dom';
import { hasAllInvestingRows } from 'components/shared/GroupedAccountList/util';

const GoPaperlessView = ({
  selectAllEDelivery,
  setShowPaperlessTerms,
  hasOwnedMutualFunds,
  isMFAccountFeeWaived,
  isFullyPaperless,
  email,
  eligibleMFServiceTypeIds
}) => {

  const viewPaperlessTermsClicked = () => {
    setShowPaperlessTerms()
  }

  return (
    <div className="go-paperless-section">
      <div className="go-paperless-content">
        {isFullyPaperless ? (
          <Fragment>
            <span className="go-paperless-heading">
              You’re fully paperless!
            </span>
            <div className="go-paperless-sub-content">
              <p className="subtitle">
                Thanks for selecting e-delivery for your account documents.
              </p>
              <p className="full-content">
                By continuing to select e-delivery for all of your documents,
                you&apos;ll enjoy timely access to your documents online via our
                secure site (when the documents contain personal information).
              </p>
              <div className="notification">
                <p>
                  When documents are available, your notification will be
                  delivered to:
                </p>
                <span>
                  {`${email && email.address}`}
                  <Link to="/profile/contact-information">Edit</Link>
                </span>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <span className="go-paperless-heading">
              Going paperless is easier than ever
            </span>
            <div className="go-paperless-sub-content">
              <p className="subtitle">
                Going paperless offers a host of benefits, which include:
              </p>
              <ul>
                <li>Timely delivery of important documents</li>
                <li>Convenient access to your documents anytime, anywhere</li>
                <li>Strong security protocols to safeguard sensitive data</li>
              </ul>
            </div>
          </Fragment>
        )}
        {(hasOwnedMutualFunds && hasAllInvestingRows(eligibleMFServiceTypeIds)) && (
          <div className="waivers-content">
            {isMFAccountFeeWaived ? (
              <Fragment>
                <CheckImage />
                <p>
                  Account service fee waived based on paperless preferences.*
                </p>
              </Fragment>
            ) : (
              <Fragment>
                <WarningImage />
                <p>Waive your account service fee by going paperless.*</p>
              </Fragment>
            )}
          </div>
        )}
        <div className="go-paperless-footer b-flex">
          {!isFullyPaperless && (
            <AAMBeaconButton
              id="go-paperless-switch-all-edelivery-button"
              onBeaconEventClick={selectAllEDelivery}
              variant="primary"
              scale="jumbo"
            >
                Switch all to e-delivery
            </AAMBeaconButton>
          )}
          <AAMBeaconButton
            onBeaconEventClick={viewPaperlessTermsClicked}
            variant={'tertiary'}
            scale="normal"
          >
            View Paperless Terms
          </AAMBeaconButton>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  hasOwnedMutualFunds: hasOwnedMutualFunds(state),
  isMFAccountFeeWaived: isMFAccountServiceFeeWaived(state),
  isFullyPaperless: isFullyPaperlessPreferences(state),
  email: getPrimaryEmailAddress(state),
  eligibleMFServiceTypeIds: getEligibleServiceTypeIds(state)
});

export default connect(mapStateToProps)(GoPaperlessView);
